import React, { useState } from 'react';
import { Button } from '@crisellevaldez/speculo-ui';
import { Copy, CheckCircle } from 'lucide-react';

interface CodeBlockProps {
  code: string;
  language?: string;
  showCopyButton?: boolean;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({
  code,
  language = 'javascript',
  showCopyButton = true,
}) => {
  const [codeCopied, setCodeCopied] = useState(false);

  const copyCodeToClipboard = () => {
    navigator.clipboard.writeText(code).then(() => {
      setCodeCopied(true);
      setTimeout(() => setCodeCopied(false), 3000);
    });
  };

  return (
    <div className="relative">
      <pre
        className={`bg-gray-800 text-white p-4 rounded-md text-xs overflow-x-auto language-${language}`}
      >
        {code}
      </pre>
      {showCopyButton && (
        <Button
          variant="outline"
          size="sm"
          className="absolute top-2 right-2 bg-white gap-2"
          onClick={copyCodeToClipboard}
        >
          {codeCopied ? <CheckCircle className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
          {codeCopied ? 'Copied!' : 'Copy'}
        </Button>
      )}
    </div>
  );
};

export default CodeBlock;
